import { Menu } from 'lucide-react';

export function PageHeader({
  title,
  subtitle,
  icon: Icon,
  children,
  onMenuToggle,
  isSidebarOpen = false,
}) {
  return (
    <div className="border-b border-slate-200 bg-white px-4 py-4 sm:px-6 min-[1200px]:px-8 min-[1200px]:py-6">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-3 sm:gap-4">
          {onMenuToggle && (
            <button
              type="button"
              onClick={onMenuToggle}
              className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-slate-50 text-slate-700 transition-colors hover:bg-slate-100 md:hidden"
              aria-label="Toggle sidebar"
              aria-expanded={isSidebarOpen}
              aria-controls="app-sidebar"
            >
              <Menu className="h-5 w-5" />
            </button>
          )}

          {Icon && (
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gradient-to-r from-blue-600 to-indigo-700">
              <Icon className="h-6 w-6 text-white" />
            </div>
          )}

          <div className="min-w-0">
            <h1 className="text-xl font-bold text-slate-900 sm:text-2xl">{title}</h1>
            {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
          </div>
        </div>

        {children && (
          <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center md:justify-end">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
